<!-- One entry renderer, used by both the columns and the legal row. An entry
     with a destination becomes a real anchor; a label-only entry stays text
     rather than an href-less anchor that looks clickable and is not. -->
<ng-template #entryTpl let-entry>
  @if (entry.link) {
    @if (entry.external) {
      <a class="site-footer__link" [href]="entry.link" target="_blank" rel="noopener noreferrer">{{
        entry.label
      }}</a>
    } @else {
      <a class="site-footer__link" [routerLink]="entry.link">{{ entry.label }}</a>
    }
  } @else {
    <span class="site-footer__text">{{ entry.label }}</span>
  }
</ng-template>

<footer class="site-footer" role="contentinfo">
  <div class="site-footer__inner">
    <div class="site-footer__top">
      <div class="site-footer__brand">
        <a class="site-footer__logo" [routerLink]="logoLink" aria-label="Seech home">
          <img class="site-footer__logo-img" [src]="logoUrl" alt="Seech" />
        </a>
        @if (slogan) {
          <p class="site-footer__slogan">{{ slogan }}</p>
        }
      </div>

      <nav class="site-footer__columns" aria-label="Footer">
        @for (column of columns; track column.heading) {
          <div class="site-footer__column">
            <h2 class="site-footer__heading">{{ column.heading }}</h2>
            <ul class="site-footer__list">
              @for (entry of column.entries; track entry.label) {
                <li>
                  <ng-container
                    *ngTemplateOutlet="entryTpl; context: { $implicit: entry }"
                  ></ng-container>
                </li>
              }
            </ul>
          </div>
        }
      </nav>
    </div>

    <div class="site-footer__bottom">
      <p class="site-footer__copyright">© {{ currentYear }} Seech. All rights reserved.</p>

      @if (legalEntries.length) {
        <ul class="site-footer__legal">
          @for (entry of legalEntries; track entry.label) {
            <li>
              <ng-container
                *ngTemplateOutlet="entryTpl; context: { $implicit: entry }"
              ></ng-container>
            </li>
          }
        </ul>
      }
    </div>
  </div>
</footer>
